<template>
  <div class="app-root">
    <div v-if="initializing || (isAuthenticated && !dataLoaded)" class="splash">
      <div class="splash__spinner" />
      Cargando…
    </div>
    <LoginScreen v-else-if="!isAuthenticated" />
    <SicamexApp
      v-else
      :initialScreen="'cliente'"
      :initialMode="'tarjetas'"
      :store="store"
      :auth="auth"
    />
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue'
import { useAuth }  from './composables/useAuth.js'
import { useStore } from './composables/useStore.js'
import LoginScreen  from './components/LoginScreen.vue'
import SicamexApp   from './components/SicamexApp.vue'

const auth  = useAuth()
const store = useStore()

const { isAuthenticated, companyId, chainId } = auth

const initializing = ref(true)
const dataLoaded   = ref(false)

watch(isAuthenticated, async (authed) => {
  if (authed && !dataLoaded.value) {
    await store.loadAll(companyId.value, chainId.value)
    dataLoaded.value = true
  }
}, { immediate: false })

function handleUnauthenticated() {
  auth.logout()
  dataLoaded.value = false
}

onMounted(async () => {
  window.addEventListener('sicamex:unauthenticated', handleUnauthenticated)
  if (isAuthenticated.value) {
    await store.loadAll(companyId.value, chainId.value)
    dataLoaded.value = true
  }
  initializing.value = false
})

onUnmounted(() => {
  window.removeEventListener('sicamex:unauthenticated', handleUnauthenticated)
})
</script>

<style>
@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>

<style scoped>
.app-root {
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

.splash {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
  height: 100vh;
  background: var(--bg);
  font-family: var(--ff-body);
  font-size: 14px;
  color: var(--text-2);
}

.splash__spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--border);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}
</style>
